export default "__VITE_ASSET__BCtjVbwe__"